"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BladeGoBackButton = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var ButtonAction_1 = require("../ButtonAction");
var Icon_1 = require("../Icon");
var StaticContent_1 = require("../StaticContent");
var BladeGoBackButton = function (props) {
    var backToTopLabel = props.backToTopLabel, content = props.content, onClick = props.onClick, targetBladeName = props.targetBladeName, others = __rest(props, ["backToTopLabel", "content", "onClick", "targetBladeName"]) // tslint:disable-line
    ;
    if (!targetBladeName) {
        return null;
    }
    var backToTopSpan;
    if (backToTopLabel) {
        backToTopSpan = (React.createElement(React.Fragment, null,
            React.createElement("span", null, backToTopLabel),
            React.createElement("span", { className: "sr-only" }, targetBladeName)));
    }
    else if (content) {
        backToTopSpan = (React.createElement(React.Fragment, null,
            React.createElement(StaticContent_1.StaticContent, { "aria-hidden": true, content: content.PreviousBtnText, tagName: "span" }),
            React.createElement(StaticContent_1.StaticContent, { className: "sr-only", content: content.PreviousBtnScreenreaderText, params: targetBladeName, tagName: "span" })));
    }
    return (React.createElement("div", { className: "blade-go-back" },
        React.createElement(ButtonAction_1.ButtonActionSubtle, __assign({}, others, { className: "blade-go-back-btn btn-link", onClick: onClick }),
            React.createElement(Icon_1.Icon, { symbol: "controlAccordionClose24", type: "svginline" }),
            backToTopSpan)));
};
exports.BladeGoBackButton = BladeGoBackButton;
exports.BladeGoBackButton.propTypes = {
    backToTopLabel: PropTypes.string,
    content: PropTypes.any,
    onClick: PropTypes.func,
    targetBladeName: PropTypes.string,
};
exports.BladeGoBackButton.defaultProps = {
    // tslint:disable-next-line
    onClick: function () { },
};
exports.default = exports.BladeGoBackButton;
